import React from 'react'

// style
import "assets/css/loading.css";

export default function Loading() {
    return (
        <div className="carregandoCmp">
            <div className="box">
                <img src={require("assets/img/loading.gif")}></img>
            </div>
        </div>
    )
}
